import React from 'react';
import { connect, batch } from 'react-redux';

import {
    toggleIsFetchingTipsFlag,
    fetchAllTips,
    updateRoleTemplateTips
} from '../../actions';
import RoleTemplatesTable from '../common/RoleTemplatesTable';
import SearchFilter from '../common/SearchFilter';
import pushMessage from '../common/PushMessage';
import CONFIG from '../../config';

class RoleTemplatesTips extends React.Component {

    getFilterDropDown = (filterProps, dataIndex) => {
        const { setSelectedKeys, selectedKeys, confirm, clearFilters } = filterProps;
        return (
            <SearchFilter
                dataIndex={dataIndex}
                searchString={selectedKeys[0]}
                setSearchString={setSelectedKeys}
                confirm={confirm}
                handleClear={this.handleClear}
                handleSearch={this.handleFilter}
                clearFilters={clearFilters}
            />
        )
    }

    columnFilters = {
        filterDropdown: (filterProps) => this.getFilterDropDown(filterProps, "title"),
        sorter: true
    }

    filterSort = {}

    handleFilter = (title, confirm) => {
        title = title?.trim();
        if (!title && !this.filterSort.filter) {
            pushMessage(CONFIG.messageType.warning, "Please enter a search string")
            return;
        }
        else confirm()
    }

    handleClear = (clearFilters) => {
        clearFilters();
    }

    handleChange = (pagination, filters, sorter) => {

        this.filterSort = {
            filter: filters.title?.[0] ? { title: filters.title[0] } : undefined,
            sort: sorter.columnKey
                ? {
                    [sorter.columnKey]: CONFIG.sortMap[sorter.order]
                }
                : undefined
        }

        batch(() => {
            this.props.toggleIsFetchingTipsFlag(true);
            this.props.fetchAllTips({
                pageNumber: pagination.current,
                pageSize: (CONFIG.shortPageSize + 1),
                access: this.access,
                filterSort: this.filterSort
            });
        });
    }

    componentDidMount() {
        const { userRoleTemplate } = this.props;
        this.access = userRoleTemplate.templateType === CONFIG.roleTypes.admin ? CONFIG.roleTemplateAccess.fullAccess : undefined;
        this.props.toggleIsFetchingTipsFlag(true);
        this.props.fetchAllTips({ access: this.access });
    }

    render() {
        const { tips, count, assignedTips, isFetching, allTipsUserAccess, allTipsAdminAccess, updateRoleTemplateTips, templateType } = this.props;
        return (
            <RoleTemplatesTable
                dataKey="tip"
                hideColumns={templateType === CONFIG.roleTypes.admin ? [] : ['admin']}
                marginTop={true}
                bordered={true}
                data={tips}
                selectAllDisabled={this.filterSort.filter !== undefined}
                columnFilters={this.columnFilters}
                onChange={this.handleChange}
                pagination={{
                    pageSize: CONFIG.shortPageSize + 1,
                    total: count
                }}
                isFetching={isFetching}
                assignedData={assignedTips}
                allAdminAccess={allTipsAdminAccess}
                allUserAccess={allTipsUserAccess}
                updateRoleTemplateData={(updateRoleTemplateTips)}
            />
        );
    }
}

const mapStateToProps = ({ tips, roleTemplate, user }) => {
    return {
        tips: tips.data,
        count: tips.count,
        isFetching: tips.isFetching,
        assignedTips: roleTemplate.tips,
        allTipsUserAccess: roleTemplate.allTipsUserAccess,
        allTipsAdminAccess: roleTemplate.allTipsAdminAccess,
        templateType: roleTemplate.templateType,
        userRoleTemplate: user.profile ? user.profile.roleTemplate : undefined
    }
}

export default connect(
    mapStateToProps,
    {
        toggleIsFetchingTipsFlag,
        fetchAllTips,
        updateRoleTemplateTips
    }
)(RoleTemplatesTips);